export const errorCodes = {
  E10000:
    "קלט משתמש לא חוקי: שגיאה בפרטי התאריכים – תאריך צ’ק-אין לא יכול להיות בעבר; תאריך צ’ק-אאוט חייב להיות אחרי הצ’ק-אין; הפרמטר Nights הוסבר כמת בטל ובמידה וסופק, חייב להתאים למספר לילות בין צ’ק-אין לצ’ק-אאוט.",
  E10001:
    "קלט משתמש לא חוקי: שגיאה בפרטי החדרים – לא ניתן להשאיר חדר ריק; מספר החדרים חייב להיות בין 1 ל-4; בכל חדר חייב להיות לפחות מבוגר אחד; מספר המבוגרים בחדר לא יעלה על 8; סכום המבוגרים הכולל>0; גילאי ילדים חייבים להיות בין 0 ל-17.",
  E10002:
    "קלט משתמש לא חוקי: שגיאה בפרטי היעד – RadiusInMeters, אם מצוין, חייב להיות >0; Latitude בין -90 ל-90; Longitude בין -180 ל-180; לא ניתן לציין RadiusInMeters עם HotelIds או SupplierLocationIds; GeoLocationInfo לא יכול להיות עם HotelIds; אם צוינה GeoLocationInfo, חייב להיות RadiusInMeters; יש לכלול לפחות HotelLocation, HotelIds, SupplierLocationIds או GeoLocation; מספר פריטים ב-HotelIds חייב להיות מתחת למקסימום; RadiusInMeters חייב להיות ≤ { }; הערך המצוי של HotelLocation לא נמצא.",
  E10003:
    "קלט משתמש לא חוקי: שגיאה כללית – חייבים ציון תקין של DesiredResultCurrency ותושבות; DetailLevel=Default מותר רק עם חיפוש לפי מזהה מלון יחיד; Response Language שגוי (נתמך רק 'EN'); DetailLevel ערך לא נתמך.",
  E10199: "שגיאת קונפיגורציה כללית.",
  E10200: "לא נמצאו תוצאות.",
  E10201: "שגיאה בתקשורת עם הספק.",
  E10202: "שגיאת אישורים.",
  E10203: "גישה אסורה.",
  E10204: "IP לא מורשה.",
  E10205: "שגיאה בגישה למלאי.",
  E10206: "הגעת למגבלת בקשות – גבול QPS מול הספק הושג.",
  E10207: "שגיאה בתאריך הצ’ק-אין.",
  E10208: "שגיאה בשוק המקור.",
  E10209: "שגיאה במזהה המלון.",
  E10210: "שגיאה בתאריך הצ’ק-אאוט.",
  E10211: "שגיאת זמן חיפוש.",
  E10212: "שגיאה במיקום.",
  E10213: "שגיאת Pax.",
  E10214: "שגיאת תפוסה (Occupancy).",
  E10297: "שגיאה כללית בבקשה.",
  E10298: "שגיאה פנימית.",
  E10300: "הספק לא שימש כמתווך – Supplier Name: {0}, Contract Id: {1}.",
  E10301: "לא נמצאו מזהי מלונות מתאימים. Supplier Name: {0}.",
  E10302: "לא נמצאו מיקומים מתאימים. Supplier Name: {0}, Location Id: {1}.",
  E10303: "שגיאה בפיענוח נתוני ספק. Supplier Name: {0}, Contract Id: {1}.",
  E10304: "שגיאת Timeout מהספק. Supplier Name: {0}, Contract Id: {1}.",
  E10305: "קריטריון חיפוש לא נתמך. Supplier Name: {0}.",
  E10306: "קונפיגורציה שגויה במערכת הספק. Supplier Name: {0}.",
  E10307: "חיפוש לפי {0} לא נתמך על ידי הספק. Supplier Name: {1}.",
  E10308: "לא הוגדר סוג חיפוש לספק. Supplier Name: {0}.",
  E10398: "שגיאת חיפוש בלתי צפויה.",
  E10399: "שגיאה כללית בחיפוש.",
  E20000: "קלט משתמש לא חוקי: פרטי לקוח שגויים.",
  E20001: "קלט משתמש לא חוקי: פרטי כרטיס אשראי שגויים.",
  E20099: "קלט משתמש לא חוקי: שגיאה כללית בקלט.",
  E3000: "תשלום לא מאושר.",
  E20225: "לא ניתן לאשר הזמנה עקב CVV שגוי.",
  E20221: "לא ניתן לאשר הזמנה עקב מחיר שגוי שנשלח.",
  E20100: "קונפיגורציה: אין הרשאה להזמין מחירים נטו לא ניתנים לביטול.",
  E20101: "אין מספיק obligo להזמנה (הנוכחי: {X}, נדרש: {X}).",
  E20102: "מחיר ההזמנה מחוץ לטווח.",
  E20103: "ההזמנה לא מורשית לחשבון זה.",
  E20104: "הזמנה מבוטלת עבור cluster '{X}'.",
  E20105: "הזמנה מבוטלת עבור סוג שירות '{X}'.",
  E20106: "הזמנה מבוטלת עבור flow '{X}'.",
  E20107: "המשתמש '{0}' לא מורשה לבצע '{1}'.",
  E20108:
    "'ChargeAmount' '{0}' לא תקין (חייב להיות >0 ולכל היותר מחיר ההזמנה).",
  E20109: "לא ניתן לחייב service-fee.",
  E20110: "שיטת תשלום לא זמינה.",
  E20111: "ערך ההנחה לא תקין.",
  E20199: "שגיאת קונפיגורציה כללית בהזמנה.",
  E11001:
    "GetPackages לא מותר עם DetailLevel: 'Low'. יש לבצע חיפוש חדש עם אחת האפשרויות: Meta, MetaExtended, MetaNoTax, MetaAdvanced, NoPackages, NoPackagesNoTax.",
  E20300: "הזמנה לא מאושרת עקב שינוי במחיר.",
  E20301: "הזמנה לא מאושרת עקב שינוי מטבע המחיר.",
  E20302: "הזמנה לא מאושרת עקב שינוי במדיניות הביטול.",
  E20303: "הזמנה לא מאושרת עקב שינוי בריבית מדיניות הביטול.",
  E20304: "הזמנה לא מאושרת – אין זמינות בספק.",
  E20305: "התשובה מה-prebook לא התקבלה.",
  E20306: "הגיע Timeout (3 דקות) – ייתכן שההזמנה הושלמה אצל הספק.",
  E20307: "אין להזמין שוב פריט שכבר הוזמן באותה session.",
  E20308: "חיוב service-fee לא מורשה בחשבון 3D.",
  E20395: "לא התקבלה תגובת הזמנה מהספק.",
  E20396: "תקלה בתשובת הזמנה – מבנה לא ידוע.",
  E20397: "שגיאה לא מטופלת בתשובת הזמנה מהספק.",
  E20398: "שגיאת הזמנה פנימית.",
  E20200: "הזמנה לא מאושרת עקב שינוי מחיר.",
  E20201: "הזמנה לא מאושרת עקב שינוי מטבע.",
  E20202: "הזמנה לא מאושרת עקב שינוי מדיניות ביטול.",
  E20203: "הזמנה לא מאושרת עקב שינוי דמי ביטול.",
  E20204: "הזמנה לא מאושרת עקב שינוי מטבע דמי ביטול.",
  E20205: "הזמנה לא מאושרת עקב שינוי תאריכי ביטול.",
  E20206: "הזמנה לא מאושרת עקב תפוגת tariff.",
  E20207: "הזמנה לא מאושרת עקב חוסר זמינות.",
  E20208: "הזמנה לא מאושר – תקלה מספק צד שלישי.",
  E20209: "הזמנה לא מאושרת – בעיות תקשורת.",
  E20210: "הזמנה לא מאושרת – שגיאת שם נוסע.",
  E20211: "הזמנה לא מאושרת – שגיאת אימייל נוסע.",
  E20212: "הזמנה לא מאושרת – הזמנה כפולה.",
  E20213: "הזמנה לא מאושרת – בעיית קו אשראי.",
  E20214: "הזמנה לא מאושרת – בעיית הרשאה.",
  E20215: "הזמנה לא מאושרת – שגיאה כללית באישור כרטיס.",
  E20216: "הזמנה לא מאושרת – שגיאה באישור כרטיס.",
  E20217: "הזמנה לא מאושרת – פרטי כרטיס שגויים.",
  E20218: "הזמנה לא מאושרת – סוג כרטיס לא נתמך.",
  E20219: "הזמנה לא מאושרת – הגבלה לפי לאום.",
  E20220: "הזמנה לא מאושרת – סטטוס הזמנה נדחה.",
  E20297: "הזמנה לא מאושרת – שגיאה כללית בבקשה.",
  E20298: "הזמנה לא מאושרת – שגיאה כללית.",
  E20299: "שגיאה לא מטופלת מספק.",
  I0200: "מידע: פעולה הושלמה בהצלחה.",
  I0404: "מידע: לא נמצאו תוצאות. Supplier Name: {0}, Contract Id: {1}.",
  I0405: "מידע: בקשה לא נתמכת. Supplier Name: {0}, Contract Id: {1}.",
  I0406: "מידע: פרטי אשראי נשלחו ללא צורך – יתעלם מהם.",
  I0600: "מידע: שם נוסע כפול – ינסה לתקן ולשחזר.",
  I0601: "מידע: תקלה בתקשורת ספק. Supplier Name: {0}, Contract Id: {1}.",
  W4306: "אזהרה: שגיאת פענוח נתוני ספק. Supplier Name: {0}, Contract Id: {1}.",
  W4307: "אזהרה: Timeout מהספק. Supplier Name: {0}, Contract Id: {1}.",
  W4308: "אזהרה: קריטריון חיפוש לא נתמך. Supplier Name: {0}.",
  W4309: "אזהרה: קונפיגורציה שגויה במערכת הספק. Supplier Name: {0}.",
  E0300: "SessionId לא נמצא – כנראה session שפגה.",
  E0500: "שגיאה פנימית חמורה – Internal Service Error.",
  E0501: "Request {0}.{1} לא קיים.",
  E0502: "פעולה מהספק לא מיושמת.",
  E0999: "שגיאה לא ידועה.",
  E1000: "שגיאת ספק.",
  E0400: "פעולה {0} לא ניתנת על קטע במצב {1}.",
  E1100: "בקשה לא חוקית – צ’ק תקינות נכשל. בדוק פרטים נוספים.",
  E2000: "משתמש '{0}' לא מורשה לבצע '{1}'.",
  E2001: "גישה נדחתה למשתמש.",
  E2002: "הגעת למגבלת משאבים (requests per second).",
  E2050: "גישה נדחתה לקטע.",
  E2060: "אישורים לא צוינו.",
  E2061: "אימות אישורים נכשל.",
  E2062: "לא ניתן לספק Credentials ו‑SessionId יחד.",
  E2063: "כרטיס אשראי חשוד (לא עבר בדיקת הונאה).",
  E2300: "קטע לא נמצא.",
  E2301: "חוסר התאמה OrderId.",
  E3005: "תשלום לא מאושר – בעיית כרטיס.",
  E3001: "תשלום לא הושלם.",
  E3002: "חיוב service-fee לא מורשה בחשבון 3D.",
  E3010: "אין שיטות תשלום מוגדרות למשתמש.",
  E3020: "אין הרשאה להזמין מחירים נטו לא ניתנים לביטול.",
  E3030: "אין מספיק obligo להזמנה.",
  E3040: '"{}" כסוג תשלום לא תואם.',
  E3050: "שיטת תשלום לא זמינה – בדוק obligo ונדרש בתשלומים.",
  E3100: "סוג כרטיס לא מותר.",
  E3101: "הקטע כבר סומן כמשולם.",
  E3500: "כלל נסיעה לא נשלחה.",
  E3501: "Route id '{0}' לא נמצא.",
  E3502: "כבר הופקד.",
  E3800: "Car extra עם מזהה '{0}' לא נמצא.",
  E3801: "רכב עם מזהה '{0}' לא נמצא.",
  E3802: "מיקום השכרת רכב לא תקין.",
  E3803: "תנאי השכרת רכב לא זמינים.",
  E3600: "Hotel Id '{0}' לא נמצא בתוצאות החיפוש.",
  E3601: "Package Id '{0}' לא נמצא בתוצאות.",
  I3701: "מידע: לא נמצאו מזהי מלונות ממופים.",
  I3702: "מידע: לא נמצאו מיקומים ממופים.",
  W3703: "אזהרה: חיפוש לפי {0} לא נתמך על ידי הספק.",
  E4300: "שגיאה בשליפת פרטים – כשל בעיבוד תוצאות ספק.",
  E4301: "לא נמצא פריט תואם – יש לשלוח Reprice מחדש.",
  E4302: "כשל בקריאת session – session פג.",
  E4303: "מטבע '{0}' לא נתמך.",
  E1101: "מחיר ההזמנה מחוץ לטווח / ערך ההנחה לא תקין.",
  E4000: "בקשת הזמנה לא תואמת לחבילה – בדוק הקצאת חדרים/נוסעים/ילדים.",
  E4050: "לא ניתן להזמין – הספק החזיר שגיאה.",
  E4051: "ההזמנה לא מותרת בחשבון – בדוק קונטרקט.",
  E4052: "הזמנה כפולה – הספק חסם.",
  E4053: "החבילה לא זמינה כעת.",
  E4060: "לא ניתן להזמין – בעיית כסף/פיקדון.",
  E4070: "הספק דחה את הבקשה.",
  E4100: "ההזמנה לא זמינה יותר – נסה חבילה אחרת.",
  E4101: "לא ניתן להזמין את אותו פריט פעמיים באותה session.",
  E4500: "שגיאת ביטול – מדיניות שינוי/תעריף שונה או תגובת ביטול ריקה.",
  E4501: "לא ניתן לבטל – פנה לצוות טכני.",
  E4502: "ביטול פריט לא נתמך.",
  E6000: "SmartBook נכשל – שגיאה פנימית.",
  E6001: "SmartBook נכשל – שגיאת חיפוש.",
  E6002: "SmartBook נכשל – שגיאה ב-prebook.",
  E6003: "SmartBook נכשל – שגיאה בהזמנה.",
  E6007: "SmartBook: לא צוינו ContractIds למרות שדרוש.",
  E7001: "SmartBook: אין הרשאה להשתמש בתכונה דרך API.",
  E4080: "SmartBook Timeout – לא הושלמה הזמנה.",
};
